import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import { __, sprintf } from '@wordpress/i18n';
import classNames from 'classnames';
import { Component, createRef } from '@wordpress/element';
import { withInstanceId } from '@wordpress/compose';
import PropTypes from 'prop-types';
/**
 * Internal dependencies
 */

import { getFormatter } from './utils/index';
import { getColor } from './utils/color';
import { selectionLimit } from '../constants';
/**
 * A legend specifically designed for the WooCommerce admin charts.
 */

var D3Legend =
/*#__PURE__*/
function (_Component) {
  _inherits(D3Legend, _Component);

  function D3Legend() {
    var _this;

    _classCallCheck(this, D3Legend);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(D3Legend).call(this));
    _this.listRef = createRef();
    _this.state = {
      isScrollable: false
    };
    return _this;
  }

  _createClass(D3Legend, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateListScroll();
      window.addEventListener('resize', this.updateListScroll);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateListScroll);
    }
  }, {
    key: "updateListScroll",
    value: function updateListScroll() {
      if (!this || !this.listRef) {
        return;
      }

      var list = this.listRef.current;
      var scrolledToEnd = list.scrollHeight - list.scrollTop <= list.offsetHeight;
      this.setState({
        isScrollable: !scrolledToEnd
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          colorScheme = _this$props.colorScheme,
          data = _this$props.data,
          handleLegendHover = _this$props.handleLegendHover,
          handleLegendToggle = _this$props.handleLegendToggle,
          interactive = _this$props.interactive,
          legendDirection = _this$props.legendDirection,
          legendValueFormat = _this$props.legendValueFormat,
          instanceId = _this$props.instanceId,
          totalLabel = _this$props.totalLabel;
      var isScrollable = this.state.isScrollable;
      var visibleData = data.filter(function (key) {
        return key.visible;
      });
      var numberOfRowsVisible = visibleData.length;
      var showTotalLabel = legendDirection === 'column' && data.length > selectionLimit && totalLabel;
      var keys = data.length > selectionLimit ? visibleData : data;
      return createElement("div", {
        className: classNames('woocommerce-legend', "woocommerce-legend__direction-".concat(legendDirection), {
          'has-total': showTotalLabel,
          'is-scrollable': isScrollable
        }, this.props.className)
      }, createElement("ul", {
        className: "woocommerce-legend__list",
        ref: this.listRef,
        onScroll: showTotalLabel ? this.updateListScroll : null
      }, data.map(function (row) {
        return createElement("li", {
          className: classNames('woocommerce-legend__item', {
            'woocommerce-legend__item-checked': row.visible
          }),
          key: row.key,
          id: "woocommerce-legend-".concat(instanceId, "__item__").concat(row.key),
          onMouseEnter: handleLegendHover,
          onMouseLeave: handleLegendHover,
          onBlur: handleLegendHover,
          onFocus: handleLegendHover
        }, createElement("button", {
          onClick: handleLegendToggle,
          id: "woocommerce-legend-".concat(instanceId, "__item-button__").concat(row.key),
          disabled: row.visible && numberOfRowsVisible <= 1 || !row.visible && numberOfRowsVisible >= selectionLimit || !interactive,
          title: numberOfRowsVisible >= selectionLimit ? sprintf(__('You may select up to %d items.', 'woocommerce-admin'), selectionLimit) : ''
        }, createElement("div", {
          className: "woocommerce-legend__item-container"
        }, createElement("span", {
          className: classNames('woocommerce-legend__item-checkmark', {
            'woocommerce-legend__item-checkmark-checked': row.visible
          }),
          style: row.visible ? {
            color: getColor(keys, colorScheme)(row.key)
          } : null
        }), createElement("span", {
          className: "woocommerce-legend__item-title"
        }, row.label), createElement("span", {
          className: "woocommerce-legend__item-total"
        }, getFormatter(legendValueFormat)(row.total)))));
      })), showTotalLabel && createElement("div", {
        className: "woocommerce-legend__total"
      }, totalLabel));
    }
  }]);

  return D3Legend;
}(Component);

D3Legend.propTypes = {
  /**
   * Additional CSS classes.
   */
  className: PropTypes.string,

  /**
   * A chromatic color function to be passed down to d3.
   */
  colorScheme: PropTypes.func,

  /**
   * An array of `orderedKeys`.
   */
  data: PropTypes.array.isRequired,

  /**
   * Handles `onClick` event.
   */
  handleLegendToggle: PropTypes.func,

  /**
   * Handles `onMouseEnter`/`onMouseLeave` events.
   */
  handleLegendHover: PropTypes.func,

  /**
   * Determines whether or not you can click on the legend
   */
  interactive: PropTypes.bool,

  /**
   * Display legend items as a `row` or `column` inside a flex-box.
   */
  legendDirection: PropTypes.oneOf(['row', 'column']),

  /**
   * A number formatting string or function to format the value displayed in the legend.
   */
  legendValueFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

  /**
   * Label to describe the legend items. It will be displayed in the legend of
   * comparison charts when there are many.
   */
  totalLabel: PropTypes.string,
  // from withInstanceId
  instanceId: PropTypes.number
};
D3Legend.defaultProps = {
  interactive: true,
  legendDirection: 'row',
  legendValueFormat: ','
};
export default withInstanceId(D3Legend);
//# sourceMappingURL=legend.js.map